var b1 = "/static/d71ff8507993a3dd.png";

export { b1 as default };
//# sourceMappingURL=b_1.png.js.map
